// Translations for Blessed Algarve (PT, EN, ES)
export const translations = {
  pt: {
    nav: {
      portfolio: "Portefólio",
      services: "Serviços",
      about: "Sobre",
      contact: "Contacto",
      book: "Reservar sessão",
    },
    hero: {
      overline: "Estúdio de Fotografia · Algarve, Portugal",
      title: "Luz do Atlântico,\nmomentos eternos.",
      subtitle:
        "Fotografia cinematográfica de casamentos, famílias e retratos — entre falésias douradas, o mar e a luz única do Algarve.",
      cta_primary: "Marcar uma sessão",
      cta_secondary: "Ver portefólio",
      scroll: "Deslize",
    },
    portfolio: {
      overline: "Portefólio",
      title: "Histórias contadas em luz.",
      subtitle:
        "Uma seleção curada do nosso trabalho — sempre honesto, sempre humano, sempre em busca da luz certa.",
      tabs: {
        all: "Tudo",
        weddings: "Casamentos",
        family: "Família & Maternidade",
        fashion: "Retratos & Moda",
        christmas: "Ensaio de Natal",
      },
      view: "Ver galeria completa",
    },
    services: {
      overline: "Serviços & Pacotes",
      title: "Pensado para cada momento.",
      subtitle:
        "Cada sessão é desenhada à medida — partilhe-nos a sua visão e criaremos algo único.",
      note: "Preços iniciais. Pacotes personalizados disponíveis a pedido.",
      items: [
        {
          key: "wedding",
          name: "Casamento & Destination Wedding",
          price: "desde €1.200",
          duration: "8h · 2 fotógrafos",
          features: [
            "Cerimónia, preparativos e festa",
            "Galeria privada online em 4 semanas",
            "Pré-wedding incluído no Algarve",
            "Edição cinematográfica em cor e película",
          ],
        },
        {
          key: "family",
          name: "Família, Maternidade & Newborn",
          price: "desde €250",
          duration: "90 min · até 6 pessoas",
          features: [
            "Sessão em praia, quinta ou estúdio",
            "40+ fotografias editadas",
            "Guia de styling enviado antes",
            "Galeria privada para descarregar",
          ],
        },
        {
          key: "portrait",
          name: "Retratos & Editorial de Moda",
          price: "desde €250",
          duration: "60 min · 2 looks",
          features: [
            "Direção artística incluída",
            "Produção com luz natural ou flash",
            "Edição editorial cor/monocromático",
            "Entrega web + alta resolução",
          ],
        },
        {
          key: "christmas",
          name: "Ensaio de Natal",
          price: "desde €200",
          duration: "45 min · cenário temático",
          features: [
            "Cenário natalício completo no estúdio",
            "Luzes de fada e props decorativos",
            "Ideal para crianças, famílias e casais",
            "30+ fotografias editadas em tons quentes",
          ],
        },
      ],
    },
    about: {
      overline: "Sobre o Blessed Algarve",
      title: "Fotografia feita com alma, no sul de Portugal.",
      body:
        "Somos um pequeno estúdio baseado no Algarve, dedicado a captar a luz dourada, o vento salgado e as emoções verdadeiras de quem visita e vive esta costa. Acreditamos em fotografias que envelhecem bem — honestas, cinematográficas, pensadas para serem recordadas.",
      stats: [
        { value: "60+", label: "Histórias registadas" },
        { value: "8", label: "Anos no Algarve" },
        { value: "100%", label: "Amor pela luz natural" },
      ],
    },
    contact: {
      overline: "Contacto & Agendamento",
      title: "Vamos criar algo memorável.",
      subtitle:
        "Conte-nos o que tem em mente — responderemos em até 24 horas com disponibilidade e proposta personalizada.",
      tabs: { message: "Enviar mensagem", booking: "Agendar sessão" },
      form: {
        name: "Nome",
        email: "Email",
        phone: "Telefone (opcional)",
        message: "A sua mensagem",
        session_type: "Tipo de sessão",
        session_options: {
          wedding: "Casamento",
          family: "Família / Maternidade / Newborn",
          portrait: "Retrato / Moda",
          christmas: "Ensaio de Natal",
          other: "Outro",
        },
        preferred_date: "Data preferida",
        preferred_time: "Hora preferida (opcional)",
        location: "Localização desejada (opcional)",
        notes: "Notas adicionais (opcional)",
        submit_message: "Enviar mensagem",
        submit_booking: "Enviar pedido",
        sending: "A enviar…",
        success_message: "Mensagem enviada! Responderemos em breve.",
        success_booking: "Pedido de agendamento enviado! Entraremos em contacto.",
        error: "Algo correu mal. Tente novamente.",
        required: "Por favor preencha este campo.",
      },
      info: {
        email_label: "Email",
        email: "blessedalgarve@gmail.com",
        location_label: "Base",
        location: "Algarve · Portugal",
        reply_label: "Resposta",
        reply: "até 24 horas",
      },
    },
    footer: {
      tagline: "Fotografia cinematográfica no Algarve.",
      rights: "Todos os direitos reservados.",
    },
  },

  en: {
    nav: {
      portfolio: "Portfolio",
      services: "Services",
      about: "About",
      contact: "Contact",
      book: "Book a session",
    },
    hero: {
      overline: "Photography Studio · Algarve, Portugal",
      title: "Atlantic light,\ntimeless moments.",
      subtitle:
        "Cinematic photography of weddings, families and portraits — between golden cliffs, the sea and the singular light of the Algarve.",
      cta_primary: "Book a session",
      cta_secondary: "View portfolio",
      scroll: "Scroll",
    },
    portfolio: {
      overline: "Portfolio",
      title: "Stories told in light.",
      subtitle:
        "A curated selection of our work — always honest, always human, always chasing the right light.",
      tabs: {
        all: "All",
        weddings: "Weddings",
        family: "Family & Maternity",
        fashion: "Portrait & Fashion",
        christmas: "Christmas Session",
      },
      view: "View full gallery",
    },
    services: {
      overline: "Services & Packages",
      title: "Designed for every moment.",
      subtitle:
        "Each session is tailor-made — share your vision and we'll craft something unique.",
      note: "Starting prices. Custom packages available on request.",
      items: [
        {
          key: "wedding",
          name: "Wedding & Destination Wedding",
          price: "from €1,200",
          duration: "8h · 2 photographers",
          features: [
            "Ceremony, preparations and party",
            "Private online gallery in 4 weeks",
            "Pre-wedding shoot in the Algarve included",
            "Cinematic editing in colour & film tones",
          ],
        },
        {
          key: "family",
          name: "Family, Maternity & Newborn",
          price: "from €250",
          duration: "90 min · up to 6 people",
          features: [
            "Beach, farm or studio session",
            "40+ edited photographs",
            "Styling guide sent in advance",
            "Private downloadable gallery",
          ],
        },
        {
          key: "portrait",
          name: "Portrait & Editorial Fashion",
          price: "from €250",
          duration: "60 min · 2 looks",
          features: [
            "Art direction included",
            "Natural light or flash production",
            "Editorial colour / monochrome edit",
            "Web + high-resolution delivery",
          ],
        },
        {
          key: "christmas",
          name: "Christmas Session",
          price: "from €200",
          duration: "45 min · themed set",
          features: [
            "Full Christmas set inside the studio",
            "Fairy lights and decorative props",
            "Perfect for kids, families and couples",
            "30+ photographs in warm festive tones",
          ],
        },
      ],
    },
    about: {
      overline: "About Blessed Algarve",
      title: "Soulful photography from southern Portugal.",
      body:
        "We are a small studio based in the Algarve, devoted to capturing the golden light, the salty wind and the true emotions of those who visit and live on this coast. We believe in photographs that age well — honest, cinematic, made to be remembered.",
      stats: [
        { value: "60+", label: "Stories captured" },
        { value: "8", label: "Years in the Algarve" },
        { value: "100%", label: "Love for natural light" },
      ],
    },
    contact: {
      overline: "Contact & Booking",
      title: "Let's create something memorable.",
      subtitle:
        "Tell us what you have in mind — we will reply within 24 hours with availability and a tailored proposal.",
      tabs: { message: "Send a message", booking: "Book a session" },
      form: {
        name: "Name",
        email: "Email",
        phone: "Phone (optional)",
        message: "Your message",
        session_type: "Session type",
        session_options: {
          wedding: "Wedding",
          family: "Family / Maternity / Newborn",
          portrait: "Portrait / Fashion",
          christmas: "Christmas Session",
          other: "Other",
        },
        preferred_date: "Preferred date",
        preferred_time: "Preferred time (optional)",
        location: "Desired location (optional)",
        notes: "Additional notes (optional)",
        submit_message: "Send message",
        submit_booking: "Send request",
        sending: "Sending…",
        success_message: "Message sent! We'll be in touch soon.",
        success_booking: "Booking request sent! We'll get back to you.",
        error: "Something went wrong. Please try again.",
        required: "Please fill in this field.",
      },
      info: {
        email_label: "Email",
        email: "blessedalgarve@gmail.com",
        location_label: "Base",
        location: "Algarve · Portugal",
        reply_label: "Reply",
        reply: "within 24 hours",
      },
    },
    footer: {
      tagline: "Cinematic photography in the Algarve.",
      rights: "All rights reserved.",
    },
  },

  es: {
    nav: {
      portfolio: "Portafolio",
      services: "Servicios",
      about: "Sobre",
      contact: "Contacto",
      book: "Reservar sesión",
    },
    hero: {
      overline: "Estudio de Fotografía · Algarve, Portugal",
      title: "Luz del Atlántico,\nmomentos eternos.",
      subtitle:
        "Fotografía cinematográfica de bodas, familias y retratos — entre acantilados dorados, el mar y la luz única del Algarve.",
      cta_primary: "Reservar sesión",
      cta_secondary: "Ver portafolio",
      scroll: "Desliza",
    },
    portfolio: {
      overline: "Portafolio",
      title: "Historias contadas en luz.",
      subtitle:
        "Una selección cuidada de nuestro trabajo — siempre honesto, siempre humano, siempre buscando la luz correcta.",
      tabs: {
        all: "Todo",
        weddings: "Bodas",
        family: "Familia & Maternidad",
        fashion: "Retrato & Moda",
        christmas: "Sesión de Navidad",
      },
      view: "Ver galería completa",
    },
    services: {
      overline: "Servicios & Paquetes",
      title: "Diseñado para cada momento.",
      subtitle:
        "Cada sesión se diseña a medida — comparte tu visión y crearemos algo único.",
      note: "Precios iniciales. Paquetes personalizados bajo petición.",
      items: [
        {
          key: "wedding",
          name: "Boda & Destination Wedding",
          price: "desde 1.200 €",
          duration: "8h · 2 fotógrafos",
          features: [
            "Ceremonia, preparativos y fiesta",
            "Galería privada online en 4 semanas",
            "Pre-boda en el Algarve incluido",
            "Edición cinematográfica en color y film",
          ],
        },
        {
          key: "family",
          name: "Familia, Maternidad & Newborn",
          price: "desde 250 €",
          duration: "90 min · hasta 6 personas",
          features: [
            "Sesión en playa, finca o estudio",
            "40+ fotografías editadas",
            "Guía de styling previa",
            "Galería privada descargable",
          ],
        },
        {
          key: "portrait",
          name: "Retrato & Editorial de Moda",
          price: "desde 250 €",
          duration: "60 min · 2 looks",
          features: [
            "Dirección artística incluida",
            "Luz natural o flash",
            "Edición editorial color/blanco y negro",
            "Entrega web + alta resolución",
          ],
        },
        {
          key: "christmas",
          name: "Sesión de Navidad",
          price: "desde 200 €",
          duration: "45 min · set temático",
          features: [
            "Set navideño completo en el estudio",
            "Luces de hada y props decorativos",
            "Ideal para niños, familias y parejas",
            "30+ fotografías en tonos cálidos festivos",
          ],
        },
      ],
    },
    about: {
      overline: "Sobre Blessed Algarve",
      title: "Fotografía con alma, en el sur de Portugal.",
      body:
        "Somos un pequeño estudio en el Algarve, dedicado a capturar la luz dorada, el viento salado y las emociones reales de quienes visitan y viven esta costa. Creemos en fotografías que envejecen bien — honestas, cinematográficas, hechas para recordarse.",
      stats: [
        { value: "60+", label: "Historias capturadas" },
        { value: "8", label: "Años en el Algarve" },
        { value: "100%", label: "Amor por la luz natural" },
      ],
    },
    contact: {
      overline: "Contacto & Reserva",
      title: "Creemos algo memorable.",
      subtitle:
        "Cuéntanos qué tienes en mente — respondemos en 24 horas con disponibilidad y una propuesta a medida.",
      tabs: { message: "Enviar mensaje", booking: "Reservar sesión" },
      form: {
        name: "Nombre",
        email: "Email",
        phone: "Teléfono (opcional)",
        message: "Tu mensaje",
        session_type: "Tipo de sesión",
        session_options: {
          wedding: "Boda",
          family: "Familia / Maternidad / Newborn",
          portrait: "Retrato / Moda",
          christmas: "Sesión de Navidad",
          other: "Otro",
        },
        preferred_date: "Fecha preferida",
        preferred_time: "Hora preferida (opcional)",
        location: "Ubicación deseada (opcional)",
        notes: "Notas adicionales (opcional)",
        submit_message: "Enviar mensaje",
        submit_booking: "Enviar solicitud",
        sending: "Enviando…",
        success_message: "¡Mensaje enviado! Te responderemos pronto.",
        success_booking: "¡Solicitud enviada! Te contactaremos.",
        error: "Algo salió mal. Inténtalo de nuevo.",
        required: "Por favor completa este campo.",
      },
      info: {
        email_label: "Email",
        email: "blessedalgarve@gmail.com",
        location_label: "Base",
        location: "Algarve · Portugal",
        reply_label: "Respuesta",
        reply: "en 24 horas",
      },
    },
    footer: {
      tagline: "Fotografía cinematográfica en el Algarve.",
      rights: "Todos los derechos reservados.",
    },
  },
};
